import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => ({
  kind: null,
  options: null
});

const panel = createReducer(getDefaultState(), {
  [Constants.panel.open]: (state, { kind, options }) => ({
    ...state,
    kind,
    options
  }),
  [Constants.panel.close]: (state) => ({
    ...state,
    kind: null,
    options: null
  })
});

export default panel;
